<template>
  <div class="home">
    <Header
      :openAuthPanel="openAuthPanel"
      :openAuthPanelAndRegister="openAuthPanelAndRegister"
      @auth-panel-closed="
        (openAuthPanel = false), (openAuthPanelAndRegister = false)
      "
      @goToSection="goToSection"
    />
    <Showcase @open-app="openAuthPanel = true" @goToSection="goToSection" />
    <Services />
    <Locations />
    <!-- in the header there's a wathcher which watches the openAuthPanel prop -->
    <Helpful @open-app="openAuthPanel = true" />
    <Footer
      @open-app="openAuthPanel = true"
      @register-dentist="openAuthPanelAndRegister = true"
    />

    <MessagePanel />
  </div>
</template>

<script>
import Header from "./Header";
import Showcase from "./Showcase";
import Services from "./Services";
import Locations from "./Locations";
import Helpful from "./Helpful";
import Footer from "./Footer";
import MessagePanel from "./MessagePanel.vue";
export default {
  name: "Home",
  components: {
    Header,
    Showcase,
    Services,
    Locations,
    Helpful,
    Footer,
    MessagePanel
  },
  data() {
    return {
      openAuthPanel: false,
      openAuthPanelAndRegister: false,
    };
  },
  methods: {
    goToSection(s) {
      const el = document.getElementById(s);
      const header = document.querySelector(".home__header");

      if (!el) return;

      const headerHeight = header?.offsetHeight || 0;
      const isMobile = window.matchMedia("(max-width: 768px)").matches;

      const y =
        el.getBoundingClientRect().top +
        window.pageYOffset -
        (isMobile ? 0 : headerHeight);

      window.scrollTo({
        top: y + (isMobile ? 0 : 30),
        behavior: "smooth",
      });
    },
  },
};
</script>